var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3553 17.0122V18.6766H11.4613C12.2095 18.6766 12.8162 19.2834 12.8162 20.0316C12.8162 20.7798 12.2095 21.3866 11.4613 21.3866H10.3553V22.645C10.3553 23.3932 9.74854 24 9.00032 24C8.2521 24 7.64535 23.3932 7.64535 22.645V21.3866H6.53896C5.79098 21.3866 5.18399 20.7797 5.18399 20.0316C5.18399 19.2836 5.79098 18.6766 6.53896 18.6766H7.64535V17.0122C3.53446 16.3568 0.44043 12.7844 0.44043 8.55989C0.44043 3.83962 4.28001 0 9.00032 0C13.7206 0 17.5604 3.83958 17.5604 8.55989C17.5604 12.7845 14.4663 16.3568 10.3553 17.0122ZM3.15018 8.55989C3.15018 11.7851 5.77513 14.4098 9.00027 14.4098C12.2256 14.4098 14.8504 11.7852 14.8504 8.55989C14.8504 5.33456 12.2255 2.70998 9.00027 2.70998C5.77518 2.70998 3.15018 5.33466 3.15018 8.55989Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.ac35d2cbfd2d3d28f3dfa0e816933b16.svg";
export { ForwardRef as ReactComponent };